import { RootState } from '@/App/store';

export const selectDisplayRuleStateMap = (state: RootState) => state.displayRules;
